import React, { useContext, Suspense, useEffect, lazy } from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import routes from "../routes";

import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Main from "../containers/Main";
import ThemedSuspense from "../components/ThemedSuspense";
import { SidebarContext } from "../context/SidebarContext";

const Page404 = lazy(() => import("../pages/404"));

function Layout() {
  const { isSidebarOpen, closeSidebar } = useContext(SidebarContext);
  let location = useLocation();
  const user = JSON.parse(sessionStorage.getItem("user"));

  // Define allowed routes for different user types
  const cityUserRoutesList = ["/facilities", "/users", "/adduser", "/pdf","/document","/invoice", "/generatecertificate", "/reports"];
  const moderatorRoutesList = ["/addfacility", "/facilities"];

  // Filter routes based on user role
  let filteredRoutes = routes;

  if (user.role === "city_user") {
    filteredRoutes = routes.filter((route) =>
      cityUserRoutesList.includes(route.path)
    );
  } else if (user.displayName === "moderator") {
    filteredRoutes = routes.filter((route) =>
      moderatorRoutesList.includes(route.path)
    );
  }

  useEffect(() => {
    closeSidebar();
  }, [location]);

  return (
    <div
      className={`flex h-screen bg-gray-50 dark:bg-gray-900 ${
        isSidebarOpen && "overflow-hidden"
      }`}
    >
      <Sidebar />

      <div className="flex flex-col flex-1 w-full">
        <Header />
        <Main>
          <Suspense fallback={<ThemedSuspense />}>
            <Switch>
              {filteredRoutes.map((route, i) => {
                return route.component ? (
                  <Route
                    key={i}
                    exact={true}
                    path={`/app${route.path}`}
                    component={route.component}
                  />
                ) : null;
              })}
              <Redirect exact from="/app" to="/app/facilities" />
              <Route component={Page404} />
            </Switch>
          </Suspense>
        </Main>
      </div>
    </div>
  );
}

export default Layout;
